import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=30769836&scoped=true&"
import script from "./Section5.vue?vue&type=script&lang=js&"
export * from "./Section5.vue?vue&type=script&lang=js&"
import style0 from "./Section5.vue?vue&type=style&index=0&id=30769836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30769836",
  null
  
)

export default component.exports